import * as tslib_1 from "tslib";
import React from 'react';
import styled from 'styled-components';
var CalendarHeaderBox = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  width: 296px;\n  height: 54px;\n"], ["\n  display: flex;\n  width: 296px;\n  height: 54px;\n"])));
// tslint:disable-next-line:no-any
export default function CalendarHeaderLayout(props) {
    return React.createElement(CalendarHeaderBox, null, props.children);
}
var templateObject_1;
//# sourceMappingURL=CalendarHeaderLayout.js.map